<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print_connect</mat-icon>
      <span>Imprimir Cadastros Agrupados</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- LOADING STATE (Full body) -->
  @if (isLoading) {
  <div class="loading-container no-print">
    <app-loading-box width="100%" height="300px"></app-loading-box>
  </div>
  }

  <!-- MAIN CONTENT: Handles both Filter Step and Report Step in layout -->

  <!-- STEP: FILTRO (Visible if step=filtro) -->
  @if (step === 'filtro' && !isLoading) {
  <div class="content-body no-print">
    <form [formGroup]="formAgrupado" class="filter-form">
      <p class="mb-3">Selecione a opção de agrupamento:</p>
      <mat-radio-group formControlName="tipoAgrupamento" class="d-flex flex-column gap-2 mb-3">
        <mat-radio-button value="1">UFs</mat-radio-button>
        <mat-radio-button value="2">UFs - Municípios</mat-radio-button>
        <mat-radio-button value="3">UFs - Municípios - Bairros</mat-radio-button>
      </mat-radio-group>
      <mat-checkbox formControlName="imprimeEndereco"> Imprime endereço do contato </mat-checkbox>
    </form>
  </div>
  }

  <!-- STEP: RELATORIO (Visible if step=relatorio) -->
  <div [hidden]="step !== 'relatorio' || isLoading" class="content-body modal-print-container">
    <!-- Header for Print/Visual purposes inside the body -->
    @if (step === 'relatorio') {
    <h3 class="mb-3">Relatório Consolidado de Contatos</h3>
    }

    @for (grupo of relatorioAgrupado; track grupo) {
    <div class="grupo-block">
      <div class="group-header">
        {{ grupo.titulo }}
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="grupo.itens">
          <!-- Nome Column -->
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let element">
              <div>{{ element.nome }}</div>
              @if (element.enderecoCompleto) {
              <div class="small">
                {{ element.enderecoCompleto }}
              </div>
              }
            </td>
          </ng-container>
          <!-- Documento Column -->
          <ng-container matColumnDef="documento">
            <th mat-header-cell *matHeaderCellDef>CPF/CNPJ</th>
            <td mat-cell *matCellDef="let element">{{ element.cpfCnpj | cpfCnpj }}</td>
          </ng-container>
          <!-- Cidade Column -->
          <ng-container matColumnDef="cidade">
            <th mat-header-cell *matHeaderCellDef>Município</th>
            <td mat-cell *matCellDef="let element">{{ element.cidade }}</td>
          </ng-container>
          <!-- Contato Column -->
          <ng-container matColumnDef="contato">
            <th mat-header-cell *matHeaderCellDef>Telefone / Celular</th>
            <td mat-cell *matCellDef="let element">
              @if (element.telefone) {
              <span>{{ element.telefone | foneMask }}</span>
              }
              @if (element.telefone && element.celular) {
              <span> / </span>
              }
              @if (element.celular) {
              <span>{{ element.celular | foneMask }}</span>
              }
            </td>
          </ng-container>
          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>E-mail</th>
            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    }

    <!-- EMPTY STATE -->
    @if (!isLoading && relatorioAgrupado.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <!-- FOOTER ACTIONS -->
  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="step === 'relatorio' ? voltar() : fechar()">
      {{ step === 'relatorio' ? 'Voltar' : 'Cancelar' }}
    </button>

    @if (step === 'filtro') {
    <button mat-flat-button class="btn-primary" (click)="submitAgrupado()">Imprimir</button>
    }

    @if (step === 'relatorio' && !isLoading && relatorioAgrupado.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>